import { css } from '@emotion/react';
import { p2r, Primary } from '../../styles/fonts';
import { colors } from '../../styles';

const styles = css`
  .references-list {
    position: relative;
  }

  .references-list::before {
    position: absolute;
    top: ${p2r(-20)};
    left: 0;
    display: block;
    width: 100%;
    max-width: 30%;
    min-height: ${p2r(1)};
    content: '';
    background: ${colors.black};
  }

  .references-list__link-number {
    text-decoration: none;
  }

  .references-list__link {
    font-family: ${Primary};
    font-size: ${p2r(14)};
    line-height: ${p2r(28)};
    color: ${colors.black};
    text-decoration: none;

    a {
      color: ${colors.black};
    }
  }

  .references-list__link-wrapper {
    display: flex;
    align-items: baseline;
  }
`;

export default styles;
